module.exports = __webpack_public_path__ + "img/xxnl-phone-img.d37e621b.png";